import React from "react";
import "./index.css";
import { MdError } from "react-icons/md";

export default function MyResult({ status, title, subTitle, extra }) {
  return (
    <>
      {status ? (
        status === "error" ? (
          <>
            {/* error */}
            <div className="mr-icon-error">
              <MdError style={{ fontSize: "90px" }} />
            </div>
            <div className="mr-title-error">{title}</div>
            <div className="mr-subtitle-error">{subTitle}</div>
            <div className="mr-btn-area">
              {extra.map((btn, idx) => {
                return btn;
              })}
            </div>
          </>
        ) : status === "success" ? (
          <>{/* success */}</>
        ) : null
      ) : (
        <>
          {/* others */}
          <div className="mr-icon-info">
            <MdError style={{ fontSize: "90px" }} />
          </div>
          <div className="mr-title-info">{title}</div>
          <div className="mr-subtitle-info">{subTitle}</div>
          <div className="mr-btn-area">
            {extra.map((btn, idx) => {
              return btn;
            })}
          </div>
        </>
      )}
    </>
  );
}
